import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService } from "kea-resource";
import { ParamsEstadisticasClientes } from 'app/models/requireme';

const controller = rpcController("EstadisticasClientes");

/**Resource del reporte de estadísticas de clientes*/
export const RepEstadisticasClientes = cacheResource({
    Generar: async (
        parametros: ParamsEstadisticasClientes): Promise<string> =>
     await controller("GenerarReporteEstadisticasClientes", {}, parametros)
}, {
    }, {

    })


// WEBPACK FOOTER //
// ./app/resources/items/estadisticasclientes.tsx